<app-header></app-header>
<router-outlet (activate)="onActivate($event)"></router-outlet>
<app-footer></app-footer>
<cookie-law name="TaajServicesCookieLaw" learnMore="/privacy-policy" target="_self">
    This website uses cookies to improve your experience. We'll assume you're ok with this, but you can opt-out if you wish.
    <a href="/privacy-policy">Read more</a>
</cookie-law>